module.exports = __webpack_public_path__ + "static/media/swoosh.5d059e66.jpg";